import { render } from "./BaseInput.vue?vue&type=template&id=5165f89c"
import script from "./BaseInput.vue?vue&type=script&lang=ts"
export * from "./BaseInput.vue?vue&type=script&lang=ts"

import "./BaseInput.vue?vue&type=style&index=0&id=5165f89c&lang=scss"
script.render = render

export default script